import { Link } from 'react-router-dom';
import { InstagramIcon, YouTubeIcon } from './SocialIcons';

export default function Footer() {
  return (
    <footer className="bg-black border-t border-white/10 px-6 py-10">
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">

        <Link to="/" className="text-sm font-black tracking-tighter uppercase italic text-white/80 hover:text-white transition-colors">
          Blackmagic <span className="text-white/40">Films</span>
        </Link>

        <nav className="flex items-center gap-6 text-xs uppercase tracking-[0.2em] text-white/50">
          <Link to="/reel" className="hover:text-white transition-colors">Reel</Link>
          <Link to="/equipment" className="hover:text-white transition-colors">Equipment</Link>
          <Link to="/content-creation" className="hover:text-amber-400 transition-colors text-amber-400/70">Work With Me</Link>
        </nav>

        <div className="flex items-center gap-4">
          <a
            href="https://www.instagram.com/blackmagicfilms_"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/50 hover:text-white transition-colors"
            aria-label="Instagram"
          >
            <InstagramIcon />
          </a>
          <a
            href="https://www.youtube.com/@blackmagickuper"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white/50 hover:text-white transition-colors"
            aria-label="YouTube"
          >
            <YouTubeIcon />
          </a>
        </div>

      </div>
      <p className="text-center text-white/20 text-xs mt-8">
        © {new Date().getFullYear()} Black Magic Films · All rights reserved.
      </p>
      <p className="text-center text-white/20 text-xs mt-2">
        <a href="https://www.risemyrank.com" target="_blank" rel="noopener noreferrer" className="hover:text-white/40 transition-colors">Rise My Rank</a>
        {' · '}
        <a href="https://apertureslate.org" target="_blank" rel="noopener noreferrer" className="hover:text-white/40 transition-colors">Aperture Slate</a>
      </p>
    </footer>
  );
}
